<template>
  <div class="card" id="post-tags-select">
    <div class="card-body">
      <div class="divide-y">
        <div class="row">
          <h3 class="card-title title">Теги</h3>
          <span class="col-12">

            <Multiselect
                @change="onChange"
                v-model="fields.tags_id"
                mode="tags"
                placeholder="Не выбрано"
                noResultsText="Результатов не найдено"
                :close-on-select="true"
                :options="getValues()"
                :searchable="true"
                :trackBy="'title'"
            >
              <template v-slot:tag="{ option, handleTagRemove, disabled }">
                <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
                  <div class="user-name">{{ option.title }}</div>
                  <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                    <span class="multiselect-tag-remove-icon"></span>
                  </span>
                </div>
              </template>
              <template v-slot:option="{ option }">
                <div class="option-user">
                  <div class="user-name">
                    {{ option.title }}
                  </div>
                </div>
              </template>
            </Multiselect>
          </span>
          <div v-if="v$.tags_id.$invalid">
            <span :class="{'is-invalid': v$.tags_id.$invalid && v$.tags_id.$dirty}"></span>
            <div class="invalid-feedback" v-for="error of v$.tags_id.$silentErrors" :key="error.$uid">
              {{ error.$message }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import {useVuelidate} from "@vuelidate/core/dist/index.esm"
import Multiselect from "@/plugins/multiselect"
import {minLength} from "@/plugins/vuelidator"
import Api from "./services/Api"

export default defineComponent({
  name: "Tags",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let tagValues = ref([])

    const fields = reactive({
      tags_id: [],
    })

    onMounted(async () => {
      fields.tags_id = props.data.val;

      let tags = await Api.tags()

      setValues(tags);
    })

    watch(() => props.data.val, (val) => {
      fields.tags_id = val
    }, {immediate: true})

    watch(() => props.data["validations"], (val) => {
      validate(() => {
        if (val?.tags_id !== undefined) {
          $externalResults.tags_id = val["tags_id"][0]
        }
      })
    })

    function setValues(items) {
      let filtered = []
      for (let prop in items) {
        let obj = items[prop]

        filtered.push({
          value: obj?.id ?? null,
          title: obj?.title ?? "",
        })
      }

      tagValues.value = filtered
    }

    function getValues() {
      return tagValues.value;
    }

    const rules = {
      tags_id: {
        minLength: minLength(0),
      },
    }

    let $externalResults = reactive({})

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function validate(fn) {
      v$.value.$clearExternalResults()

      return v$.value.$validate().then(async () => {
        await fn()
      })
    }

    function onChange(value) {
      fields.tags_id = value
      validate(() => {})
      emit("onChange", fields.tags_id)
    }

    return {
      onChange,
      getValues,
      v$,
      fields,
    }
  }
})
</script>
